import MyAxios from "@/utilize/MyAxios";
import { useMutation } from "@tanstack/react-query";

const useRemoveUser = () => {
  return useMutation({
    mutationFn: (id: string) => MyAxios.delete(`/users/${id}`),
  });
};

export default useRemoveUser;
